module.exports = __webpack_public_path__ + "static/media/client-img3.e931e1db.jpg";